import React from 'react';
const COVER_URL = 'https://cdn.magicpatterns.com/uploads/8iTMevrqiSnw8dode2jSfA/01_complete_edition_cover.png';

/**
 * 3D workbook mockup: the uploaded cover is rendered untouched as the front face,
 * with a generated spine, edge and floor shadow giving it physical depth.
 */
export function BookMockup() {
  return <div className="relative mx-auto w-full max-w-[225px] sm:max-w-[270px] lg:max-w-[315px]" data-id="element-38" data-mp="2t2dqhwrd5pf6">
      <div className="relative" style={{
      perspective: '1400px'
    }} data-id="element-39" data-mp="25cjh5p696izo">
        <div className="relative" style={{
        transform: 'rotateY(-16deg) rotateX(3deg)',
        transformStyle: 'preserve-3d'
      }} data-id="element-40" data-mp="20dgkot4c9l3b">
          {/* Page block / right edge */}
          <div aria-hidden="true" className="absolute inset-y-[6px] -right-[10px] rounded-r-[3px] bg-[#d8dee5]" style={{
          transform: 'translateZ(-14px)'
        }} data-id="element-41" data-mp="29bs7ek233yqh" />
          {/* Spine */}
          <div aria-hidden="true" className="absolute inset-y-0 -left-[13px] w-[16px] rounded-l-[3px] bg-gradient-to-b from-[#0d1a25] to-[#050c12]" style={{
          transform: 'rotateY(28deg)',
          transformOrigin: 'right center'
        }} data-id="element-42" data-mp="3kumnr2v02lst" />
          <img src={COVER_URL} alt="Front cover of the Math Made Ready 2026 Complete Edition workbook" className="relative block w-full rounded-[4px] shadow-book ring-1 ring-white/10" data-id="element-43" data-mp="1alo38n2stvpg" />
          {/* Cover sheen along the spine side */}
          <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-0 w-10 rounded-l-[4px] bg-black/25" style={{
          maskImage: 'linear-gradient(90deg, #000, transparent)',
          WebkitMaskImage: 'linear-gradient(90deg, #000, transparent)'
        }} data-id="element-44" data-mp="mwbsvjvqjhlk" />
        </div>
      </div>

      {/* Floor shadow */}
      <div aria-hidden="true" className="mx-auto mt-6 h-6 w-[82%] rounded-[50%] bg-black/60 blur-xl" data-id="element-45" data-mp="452i77a8amse" />

      {/* Pixel corner markers */}
      <span aria-hidden="true" className="absolute -left-3 -top-3 h-4 w-4 border-l-2 border-t-2 border-brand-emerald" data-id="element-46" data-mp="3s87h84uqnsl2" />
      <span aria-hidden="true" className="absolute -right-4 top-8 h-3 w-3 bg-brand-cyan" data-id="element-47" data-mp="5twl6fknoax6" />
      <span aria-hidden="true" className="absolute -left-5 bottom-24 h-3 w-3 bg-brand-gold" data-id="element-48" data-mp="ul2h10qavcy" />
    </div>;
}